import React from 'react';
import { useAIAnswerContext } from '../ai-answer-dialog/ai-answer-context';
import { QueryIntent } from '../constants';
import { PersonKnowledgeCard } from './person-knowledge-card';
import { TeamKnowledgeCard } from './team-knowledge-card';
export var KnowledgeCard = function KnowledgeCard() {
  var _useAIAnswerContext = useAIAnswerContext(),
    isAnswered = _useAIAnswerContext.isAnswered,
    hasError = _useAIAnswerContext.hasError,
    smartAnswersRoute = _useAIAnswerContext.smartAnswersRoute;
  if (isAnswered && !hasError) {
    switch (smartAnswersRoute) {
      case QueryIntent.TEAM:
        return /*#__PURE__*/React.createElement(TeamKnowledgeCard, null);
      case QueryIntent.PERSON:
        return /*#__PURE__*/React.createElement(PersonKnowledgeCard, null);
      default:
        return null;
    }
  }
  return null;
};